import {
    THREE_TIER_PARTICIPATION,
    getThreeTierParticipationCapabilities,
    getThreeTierParticipationLayerDefinition,
} from './ParticipationLayer';
import type { RoomDefinition } from './RoomDefinition';

export const TOWNHALL_PARTICIPATION = THREE_TIER_PARTICIPATION;

export const getTownhallParticipationLayerDefinition = (
    kind: typeof TOWNHALL_PARTICIPATION[number]['kind'],
) => getThreeTierParticipationLayerDefinition(kind);

export const getTownhallParticipationCapabilities = (
    kind: typeof TOWNHALL_PARTICIPATION[number]['kind'],
) => getThreeTierParticipationCapabilities(kind);

export const TOWNHALL_ROOM_DEFINITION: RoomDefinition = {
    kind: 'townhall',
    experience: 'townhall_broadcast',
    accessPolicy: 'broadcast_audience',
    orchestrationMode: 'human_led_broadcast',
    participation: TOWNHALL_PARTICIPATION,
    companionRuntime: 'telegamez_multi_companion',
    contribution: {
        defaultMode: 'recorded_audio_submission',
        allowedModes: [
            'recorded_audio_submission',
            'dial_in_audio_submission',
        ],
        allowedRuntimeKinds: ['telegamez_multi_companion'],
        transcriptOwnership: 'telegamez',
        overrides: [
            {
                layer: 'stage_primary',
                defaultMode: 'live_turn',
                allowedModes: ['live_turn'],
                allowedRuntimeKinds: ['telegamez_multi_companion'],
                transcriptOwnership: 'telegamez',
            },
            {
                layer: 'guest_temp',
                defaultMode: 'live_turn',
                allowedModes: [
                    'live_turn',
                    'speech_to_speech_session',
                ],
                allowedRuntimeKinds: [
                    'telegamez_multi_companion',
                    'third_party_speech_to_speech',
                ],
                transcriptOwnership: 'hybrid',
            },
            {
                layer: 'audience_gallery',
                defaultMode: 'recorded_audio_submission',
                allowedModes: [
                    'recorded_audio_submission',
                    'dial_in_audio_submission',
                    'text_prompt_submission',
                ],
                allowedRuntimeKinds: ['external_text_agent'],
                transcriptOwnership: 'telegamez',
            },
            {
                participantType: 'external_participant',
                defaultMode: 'text_prompt_submission',
                allowedModes: [
                    'text_prompt_submission',
                    'speech_to_speech_session',
                    'vendor_stream_session',
                ],
                allowedRuntimeKinds: [
                    'external_text_agent',
                    'third_party_speech_to_speech',
                    'vendor_managed_avatar_agent',
                ],
                transcriptOwnership: 'hybrid',
            },
        ],
    },
    renderer: 'premium_avatar',
    features: {
        requiresAuthGate: false,
        supportsSpectators: true,
        supportsCallInAudio: true,
        supportsPolls: true,
        supportsVoting: true,
        supportsRealtimeTranscript: true,
        supportsCompanionAgents: true,
        supportsPresentationOverlay: true,
        supportsPremiumAvatars: true,
        supportsWebStage: true,
        supportsProgramManifest: true,
        supportsBroadcast: true,
        supportsRecording: true,
        supportsSharedStageMedia: true,
        supportsStageFeedback: true,
        // Phase 4: default off, per direction. The Gaming Event Watch Party
        // pilot template (PR-10) flips this on for its preset.
        supportsSkills: false,
    },
};
